// import { subDays } from "date-fns";
import checkout from "./form";

const {
  formField: { country, city, location },
} = checkout;

const initialValues = {
  [country.name]: "",
  [city.name]: {},
  [location.name]: {},
};

export default initialValues;
